import { RootState } from "../store";

export const selectLanguage = (state: RootState) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return state.i18n.locale as string;
};
